/**
 * Created by Fernando Torres on 01/02/2018.
 */
import LayoutsListView from '@/views/app/layouts/layouts-list-view'
import LayoutsCreateView from '@/views/app/layouts/layouts-create-view'
import LayoutsEditView from '@/views/app/layouts/layouts-edit-view'
import LayoutsCloneView from '@/views/app/layouts/layouts-clone-view'

export default [
  {
    path: 'layouts',
    name: 'layouts',
    component: LayoutsListView,
    children: [
      {
        path: 'create',
        name: 'layouts-create',
        component: LayoutsCreateView
      },
      {
        path: ':id',
        name: 'layouts-edit',
        component: LayoutsEditView
      },
      {
        path: 'clone/:id',
        name: 'layouts-clone',
        component: LayoutsCloneView
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/app/layouts/index.js